/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, Jun 2023
 * @flow
 */


import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { Box, Card, Grid, Typography } from '@material-ui/core';
import useStyles from './useStyles';
import { useSelector } from 'react-redux';

const TablesLookup = ({ onTableSelection, allTables }) => {
  const classes = useStyles();
  const { labelsData } = useSelector(state => state);
  const { labels: strings } = labelsData;
  const [tables, setTables] = useState(allTables);

  useEffect(() => {
    setTables(allTables);
  }, [allTables]);

  const onSelection = (table) => {
    onTableSelection(table);
  }

  return (
    <Box p={1} className={classes.cardContainer}>
      <Typography variant='body2' className={classes.label}>{strings.MERGE_CHOOSE_TABLES}</Typography>
      <Box height={330} overflow={'scroll'}>
        <Grid container>
          {tables.map(table => {
            if (table.stationId) {
              return (
                <TableCard
                  key={`id-${table.stationId}`}
                  table={table}
                  onClick={() => onSelection(table)}
                />
              )
            }
          })}
        </Grid>
      </Box>
    </Box>
  );
};

const TableCard = ({ table, onClick }) => {
  const classes = useStyles();
  const { stationNumber } = table || {};
  return (
    <Grid item xs={6} sm={6} md={4} lg={2}>
      <Card elevation={0} className={table.selected ? cn(classes.tableCard, classes.selected) : classes.tableCard} onClick={onClick}>
        <Typography variant='body2' className={classes.tableText}>{stationNumber}</Typography>
      </Card>
    </Grid>
  );
};

export default TablesLookup;
